tinymce.addI18n("nb_NO", {
    "#": "#",
    "Accessibility": "Tilgjengelighet",
    "Accordion": "Trekkspillmeny",
    "Accordion body...": "Br\xf8dtekst i trekkspillmeny...",
    "Accordion summary...": "Sammendrag av trekkspillmeny...",
    "Action": "Handling",
    "Activity": "Aktivitet",
    "Address": "Adresse",
    "Advanced": "Avansert",
    "Align": "Juster",
    "Align center": "Midtstill",
    "Align left": "Venstrejuster",
    "Align right": "H\xf8yrejuster",
    "Alignment": "Justering",
    "Alignment {0}": "Justering {0}",
    "All": "Alle",
    "Alternative description": "Alternativ beskrivelse",
    "Alternative source": "Alternativ kilde",
    "Alternative source URL": "Alternativ kilde-URL",
    "Anchor": "Anker",
    "Anchor...": "Lenke...",
    "Anchors": "Forankringspunkter",
    "Animals and Nature": "Dyr og natur",
    "Arrows": "Piler",
    "B": "B",
    "Background color": "Bakgrunnsfarge",
    "Background color {0}": "Bakgrunnsfarge {0}",
    "Black": "Svart",
    "Block": "Blokk",
    "Block {0}": "Blokk {0}",
    "Blockquote": "Blockquote",
    "Blocks": "Blokker",
    "Blue": "Bl\xe5",
    "Blue component": "Bl\xe5 komponent",
    "Body": "Br\xf8dtekst",
    "Bold": "Fet",
    "Border": "Ramme",
    "Border color": "Rammefarge",
    "Border style": "Rammestil",
    "Border width": "Rammebredde",
    "Bottom": "Bunn",
    "Browse files": "Bla gjennom filer",
    "Browse for an image": "S\xf8k etter bilde",
    "Browse links": "Bla gjennom lenker",
    "Bullet list": "Punktliste",
    "Cancel": "Avbryt",
    "Caption": "Tittel",
    "Cell": "Celle",
    "Cell padding": "Cellemarg",
    "Cell properties": "Celleegenskaper",
    "Cell spacing": "Celleavstand",
    "Cell styles": "Cellestiler",
    "Cell type": "Celletype",
    "Center": "Senter",
    "Characters": "Tegn",
    "Characters (no spaces)": "Tegn (uten mellomrom)",
    "Circle": "Sirkel",
    "Class": "Klasse",
    "Clear formatting": "Fjern formateringer",
    "Close": "Lukk",
    "Code": "Kode",
    "Code sample...": "Kodeeksempel...",
    "Code view": "Kodevisning",
    "Color Picker": "Fargevelger",
    "Color swatch": "Fargepalett",
    "Cols": "Kolonner",
    "Column": "Kolonne",
    "Column clipboard actions": "Kolonne-utklippstavlehandlinger",
    "Column group": "Kolonnegruppe",
    "Column header": "Kolonneoverskrift",
    "Constrain proportions": "Begrens proporsjoner",
    "Copy": "Kopier",
    "Copy column": "Kopier kolonne",
    "Copy row": "Kopier rad",
    "Could not find the specified string.": "Kunne ikke finne den spesifiserte teksten",
    "Could not load emojis": "Kunne ikke laste inn emojier",
    "Count": "Opptelling",
    "Currency": "Valuta",
    "Current window": "N\xe5v\xe6rende vindu",
    "Custom color": "Tilpasset farge",
    "Custom...": "Tilpasset...",
    "Cut": "Klipp ut",
    "Cut column": "Kutt kolonne",
    "Cut row": "Klipp ut rad",
    "Dark Blue": "M\xf8rk bl\xe5",
    "Dark Gray": "M\xf8rk gr\xe5",
    "Dark Green": "M\xf8rkegr\xf8nn",
    "Dark Orange": "M\xf8rk oransje",
    "Dark Purple": "M\xf8rk lilla",
    "Dark Red": "M\xf8rker\xf8d",
    "Dark Turquoise": "M\xf8rk turkis",
    "Dark Yellow": "M\xf8rk gul",
    "Dashed": "Stiplet dash",
    "Date/time": "Dato/tid",
    "Decrease indent": "Reduser innrykk",
    "Default": "Standard",
    "Delete accordion": "Slett trekkspillmeny",
    "Delete column": "Slett kolonne",
    "Delete row": "Slett rad",
    "Delete table": "Slett tabell",
    "Dimensions": "St\xf8rrelser",
    "Disc": "Disk",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Stiplet dot",
    "Double": "Dobbel",
    "Drop an image here": "Slipp et bilde her",
    "Dropped file type is not supported": "Filtype st\xf8ttes ikke",
    "Edit": "Rediger",
    "Embed": "Inkluder",
    "Emojis": "Emojier",
    "Emojis...": "Emojier...",
    "Error": "Feil",
    "Error: Form submit field collision.": "Feil: Skjemafelt-innsendingskollisjon.",
    "Error: No form element found.": "Feil: Intet skjemaelement funnet.",
    "Extended Latin": "Utvidet latin",
    "Failed to initialize plugin: {0}": "Kunne ikke initialisere tillegg: {0}",
    "Failed to load plugin url: {0}": "Kunne ikke laste tillegg url: {0}",
    "Failed to load plugin: {0} from url {1}": "Kunne ikke laste tillegg: {0} from url {1}",
    "Failed to upload image: {0}": "Opplasting av bilde feilet: {0}",
    "File": "Fil",
    "Find": "S\xf8k etter",
    "Find (if searchreplace plugin activated)": "Finn (dersom tillegg for s\xf8k og erstatt er aktivert)",
    "Find and Replace": "Finn og erstatt",
    "Find and replace...": "Finn og erstatt...",
    "Find in selection": "Finn i utvalg",
    "Find whole words only": "Finn kun hele ord",
    "Flags": "Flagg",
    "Focus to contextual toolbar": "Fokus p\xe5 kontekstuell verkt\xf8ylinje",
    "Focus to element path": "Fokus p\xe5 elementsti",
    "Focus to menubar": "Fokus p\xe5 menylinje",
    "Focus to toolbar": "Fokus p\xe5 verkt\xf8ylinje",
    "Font": "Skrift",
    "Font size {0}": "Skriftst\xf8rrelse {0}",
    "Font sizes": "Fontst\xf8rrelser",
    "Font {0}": "Skrifttype {0}",
    "Fonts": "Skriftsnitt",
    "Food and Drink": "Mat og drikke",
    "Footer": "Bunntekst",
    "Format": "Format",
    "Format {0}": "Format {0}",
    "Formats": "Stiler",
    "Fullscreen": "Fullskjerm",
    "G": "G",
    "General": "Generelt",
    "Gray": "Gr\xe5",
    "Green": "Gr\xf8nn",
    "Green component": "Gr\xf8nn komponent",
    "Groove": "Rillekant",
    "Handy Shortcuts": "Nyttige snarveier",
    "Header": "Overskrift",
    "Header cell": "Overskriftscelle",
    "Heading 1": "Overskrift 1",
    "Heading 2": "Overskrift 2",
    "Heading 3": "Overskrift 3",
    "Heading 4": "Overskrift 4",
    "Heading 5": "Overskrift 5",
    "Heading 6": "Overskrift 6",
    "Headings": "Overskrifter",
    "Height": "H\xf8yde",
    "Help": "Hjelp",
    "Hex color code": "Hex fargekode",
    "Hidden": "Skjult",
    "Horizontal align": "Horisontal justering",
    "Horizontal line": "Horisontal linje",
    "Horizontal space": "Horisontal avstand",
    "ID": "Id",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID skal starte med en bokstav, kun etterfulgt av bokstaver, tall, bindestreker, prikker, kolon eller understreker.",
    "Image is decorative": "Bilde er dekorasjon",
    "Image list": "Bildeliste",
    "Image title": "Bildetittel",
    "Image...": "Bilde...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP-feil: Fant ikke Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP-feil: Feil Image Proxy URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP-feil: Avvist foresp\xf8rsel",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP-feil: Ukjent ImageProxy-feil",
    "Increase indent": "\xd8k innrykk",
    "Inline": "Innkapslet",
    "Insert": "Sett inn",
    "Insert Template": "Sett inn mal",
    "Insert accordion": "Sett inn trekkspillmeny",
    "Insert column after": "Sett inn kolonne etter",
    "Insert column before": "Sett inn kolonne f\xf8r",
    "Insert date/time": "Sett inn dato/tid",
    "Insert image": "Sett inn bilde",
    "Insert link (if link plugin activated)": "Sett inn lenke (dersom lenketillegg er aktivert)",
    "Insert row after": "Sett inn rad etter",
    "Insert row before": "Sett inn rad f\xf8r",
    "Insert table": "Sett inn tabell",
    "Insert template...": "Sett inn mal..",
    "Insert video": "Sett inn video",
    "Insert/Edit code sample": "Sett inn / endre kodeeksempel",
    "Insert/edit image": "Sett inn / rediger bilde",
    "Insert/edit link": "Sett inn / rediger lenke",
    "Insert/edit media": "Sett inn / endre media",
    "Insert/edit video": "Sett inn / rediger video",
    "Inset": "Innfelt",
    "Invalid hex color code: {0}": "Ugyldig heksadesimal fargekode: {0}",
    "Invalid input": "Ugyldig inndata",
    "Italic": "Kursiv",
    "Justify": "Blokkjuster",
    "Keyboard Navigation": "Tastaturnavigasjon",
    "Language": "Spr\xe5k",
    "Learn more...": "Les mer ...",
    "Left": "Venstre",
    "Left to right": "Venstre til h\xf8yre",
    "Light Blue": "Lys bl\xe5",
    "Light Gray": "Lys gr\xe5",
    "Light Green": "Lys gr\xf8nn",
    "Light Purple": "Lys lilla",
    "Light Red": "Lys r\xf8d",
    "Light Yellow": "Lys gul",
    "Line height": "Linjeh\xf8yde",
    "Link list": "Liste over lenker",
    "Link...": "Lenke...",
    "List Properties": "Listeegenskaper",
    "List properties...": "Listeegenskaper...",
    "Loading emojis...": "Laster emojier...",
    "Loading...": "Laster...",
    "Lower Alpha": "Sm\xe5 bokstaver",
    "Lower Greek": "Greske minuskler",
    "Lower Roman": "Sm\xe5 romertall",
    "Match case": "Versalsensitiv",
    "Mathematical": "Matematisk",
    "Media poster (Image URL)": "Mediaposter (bilde-URL)",
    "Media...": "Media..",
    "Medium Blue": "Mellombl\xe5",
    "Medium Gray": "Medium gr\xe5",
    "Medium Purple": "Medium lilla",
    "Merge cells": "Sl\xe5 sammen celler",
    "Middle": "Sentrert",
    "Midnight Blue": "Midnattbl\xe5",
    "More...": "Mer...",
    "Name": "Navn",
    "Navy Blue": "Marinebl\xe5",
    "New document": "Nytt dokument",
    "New window": "Nytt vindu",
    "Next": "Neste",
    "No": "Nei",
    "No alignment": "Ingen justering",
    "No color": "Ingen farge",
    "Nonbreaking space": "Hardt mellomrom",
    "None": "Ingen",
    "Numbered list": "Nummerliste",
    "OR": "OR",
    "Objects": "Objekter",
    "Ok": "Ok",
    "Open help dialog": "\xc5pne hjelp-dialog",
    "Open link": "\xc5pne lenke",
    "Open link in...": "\xc5pne lenke i..",
    "Open popup menu for split buttons": "\xc5pne sprettoppmeny for splitt-knapper",
    "Orange": "Oransje",
    "Outset": "Utfelt",
    "Page break": "Sideskifte",
    "Paragraph": "Avsnitt",
    "Paste": "Lim inn",
    "Paste as text": "Lim inn som tekst",
    "Paste column after": "Lim inn kolonne etter",
    "Paste column before": "Lim inn kolonne f\xf8r",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Lim inn er n\xe5 i ren tekst-modus. Kopiert innhold vil bli limt inn som ren tekst inntil du sl\xe5r av dette valget.",
    "Paste or type a link": "Lim inn eller skriv en lenke",
    "Paste row after": "Lim inn rad etter",
    "Paste row before": "Lim inn rad f\xf8r",
    "Paste your embed code below:": "Lim inn inkluderingskoden nedenfor:",
    "People": "Mennesker",
    "Plugins": "Programtillegg",
    "Plugins installed ({0}):": "Installerte tillegg ({0}):",
    "Powered by {0}": "Drevet av {0}",
    "Pre": "Pre",
    "Preferences": "Innstillinger",
    "Preformatted": "Forh\xe5ndsformatert",
    "Premium plugins:": "Premiumtillegg:",
    "Press the Up and Down arrow keys to resize the editor.": "Trykk p\xe5 opp- og nedtastene for \xe5 endre st\xf8rrelsen til redigeringsvinduet.",
    "Press the arrow keys to resize the editor.": "Trykk p\xe5 piltastene for \xe5 endre st\xf8rrelsen til redigeringsvinduet.",
    "Press {0} for help": "Trykk p\xe5 {0} for \xe5 f\xe5 hjelp",
    "Preview": "Forh\xe5ndsvis",
    "Previous": "Forrige",
    "Print": "Utskrift",
    "Print...": "Skriv ut...",
    "Purple": "Lilla",
    "Quotations": "Sitater",
    "R": "R",
    "Range 0 to 255": "Spenn 0 til 255",
    "Red": "R\xf8d",
    "Red component": "R\xf8d komponent",
    "Redo": "Redo",
    "Remove": "Fjern",
    "Remove color": "Fjern farge",
    "Remove link": "Fjern lenke",
    "Replace": "Erstatt",
    "Replace all": "Erstatt alle",
    "Replace with": "Erstatt med",
    "Resize": "Skaler",
    "Restore last draft": "Gjenopprett siste utkast",
    "Reveal or hide additional toolbar items": "Vis eller skjul ekstra elementer p\xe5 verkt\xf8ylinjen",
    "Rich Text Area": "Rik tekst-omr\xe5de",
    "Rich Text Area. Press ALT-0 for help.": "Rik-tekstomr\xe5de. Trykk ALT-0 for hjelp.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Tekstredigering. Tast ALT-F9 for meny. Tast ALT-F10 for verkt\xf8ylinje. Tast ALT-0 for hjelp.",
    "Ridge": "Ridge",
    "Right": "H\xf8yre",
    "Right to left": "H\xf8yre til venstre",
    "Row": "Rad",
    "Row clipboard actions": "Rad-utklippstavlehandlinger",
    "Row group": "Radgruppe",
    "Row header": "Radoverskrift",
    "Row properties": "Radegenskaper",
    "Row type": "Radtype",
    "Rows": "Rader",
    "Save": "Lagre",
    "Save (if save plugin activated)": "Lagre (dersom lagretillegg er aktivert)",
    "Scope": "Omfang",
    "Search": "S\xf8k",
    "Select all": "Marker alt",
    "Select...": "Velg...",
    "Selection": "Utvalg",
    "Shortcut": "Snarvei",
    "Show blocks": "Vis blokker",
    "Show caption": "Vis tittel",
    "Show invisible characters": "Vis skjulte tegn",
    "Size": "St\xf8rrelse",
    "Solid": "Solid",
    "Source": "Kilde",
    "Source code": "Kildekode",
    "Special Character": "Spesialtegn",
    "Special character...": "Spesialtegn...",
    "Split cell": "Splitt celle",
    "Square": "Firkant",
    "Start list at number": "Start liste p\xe5 nummer",
    "Strikethrough": "Gjennomstreking",
    "Style": "Stil",
    "Subscript": "Senket skrift",
    "Superscript": "Hevet skrift",
    "Switch to or from fullscreen mode": "Bytt til eller fra fullskjermmodus",
    "Symbols": "Symboler",
    "System Font": "Systemfont",
    "Table": "Tabell",
    "Table caption": "Tabelloverskrift",
    "Table properties": "Tabellegenskaper",
    "Table styles": "Tabellstiler",
    "Template": "Mal",
    "Templates": "Maler",
    "Text": "Tekst",
    "Text color": "Tekstfarge",
    "Text color {0}": "Tekstfarge {0}",
    "Text to display": "Tekst som skal vises",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Oppgitt URL ser ut til \xe5 v\xe6re en e-postadresse. \xd8nsker du \xe5 sette inn p\xe5krevet mailto: prefiks foran e-postadressen?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "URL du skrev inn ser ut som en ekstern adresse. Vil du legge til det obligatoriske prefikset http://?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Nettadressen du fylte inn ser ut til \xe5 v\xe6re en ekstern. \xd8nsker du \xe5 legge til p\xe5krevd 'https://'-prefiks?",
    "Title": "Tittel",
    "To open the popup, press Shift+Enter": "For \xe5 \xe5pne popup, trykk Shift+Enter",
    "Toggle accordion": "Vis/skjul trekkspillmeny",
    "Tools": "Verkt\xf8y",
    "Top": "Topp",
    "Travel and Places": "Reise og steder",
    "Turquoise": "Turkis",
    "Underline": "Understreking",
    "Undo": "Angre",
    "Upload": "Last opp",
    "Uploading image": "Laster opp bilde",
    "Upper Alpha": "Store bokstaver",
    "Upper Roman": "Store romertall",
    "Url": "Url",
    "User Defined": "Brukerdefinert",
    "Valid": "Gyldig",
    "Version": "Versjon",
    "Vertical align": "Vertikal justering",
    "Vertical space": "Vertikal avstand",
    "View": "Vis",
    "Visual aids": "Visuelle hjelpemidler",
    "Warn": "Advarsel",
    "White": "Hvit",
    "Width": "Bredde",
    "Word count": "Ordtelling",
    "Words": "Ord",
    "Words: {0}": "Ord: {0}",
    "Yellow": "Gul",
    "Yes": "Ja",
    "You are using {0}": "Du bruker {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Du har ikke arkivert endringene. Vil du fortsette uten \xe5 arkivere?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Nettleseren din st\xf8tter ikke direkte tilgang til utklippsboken. Bruk istedet tastatursnarveiene Ctrl+X/C/V.",
    "alignment": "justering",
    "austral sign": "austral-symbol",
    "cedi sign": "credi-symbol",
    "colon sign": "kolon-symbol",
    "cruzeiro sign": "cruzeiro-symbol",
    "currency sign": "valutasymbol",
    "dollar sign": "dollartegn",
    "dong sign": "dong-symbol",
    "drachma sign": "drachma-symbol",
    "euro-currency sign": "Euro-valutasymbol",
    "example": "eksempel",
    "formatting": "formatering",
    "french franc sign": "franske franc-symbol",
    "german penny symbol": "tysk penny-symbol",
    "guarani sign": "quarani-symbol",
    "history": "historikk",
    "hryvnia sign": "hryvina-symbol",
    "indentation": "innrykk",
    "indian rupee sign": "indisk rupee-symbol",
    "kip sign": "kip-symbol",
    "lira sign": "lire-symbol",
    "livre tournois sign": "livre tournois-symbol",
    "manat sign": "manat-symbol",
    "mill sign": "mill-symbol",
    "naira sign": "naira-symbol",
    "new sheqel sign": "ny sheqel-symbol",
    "nordic mark sign": "nordisk mark-symbol",
    "peseta sign": "peseta-symbol",
    "peso sign": "peso-symbol",
    "ruble sign": "ruble-symbol",
    "rupee sign": "rupee-symbol",
    "spesmilo sign": "spesmilo-symbol",
    "styles": "stiler",
    "tenge sign": "tenge-symbol",
    "tugrik sign": "tugrik-symbol",
    "turkish lira sign": "tyrkisk lire-symbol",
    "won sign": "won-symbol",
    "yen character": "yen-symbol",
    "yen/yuan character variant one": "yen/yuan-symbol variant en",
    "yuan character": "yuan-symbol",
    "yuan character, in hong kong and taiwan": "yuan-symbol, i Hongkong og Taiwan",
    "{0} characters": "{0} tegn",
    "{0} columns, {1} rows": "{0} s\xf8yler, {1} rader",
    "{0} words": "{0} ord"
});